<script setup lang="ts">
import type { HomeTabs } from '@/types/thread';

interface Props {
  tabs: HomeTabs[];
  selectedTab: string;
  loading?: boolean;
}

defineProps<Props>();

defineEmits<(e: 'on-change', value: HomeTabs) => void>();
</script>

<template>
  <div class="flex-center">
    <div
      v-for="tab in tabs"
      :key="tab"
      class="tab-btn flex-center"
      :class="{ 'active': selectedTab === tab, 'disabled': loading }"
      @click="$emit('on-change', tab)"
    >
      {{ $t(`home.tabs.${tab}`) }}
    </div>
  </div>
</template>

<style scoped lang="scss">
.tab-btn {
  height: 40px;
  padding: 0 16px;
  background-color: var(--white);
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  border: 1px solid var(--border-default);
  cursor: pointer;

  &.active {
    border: 1.5px solid var(--primary);
    color: var(--primary);
  }

  &:first-of-type {
    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px;
  }

  &:last-of-type {
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
  }
}
</style>
